// Module-level queue any file can push to; ToastViewport renders it.

const MAX_VISIBLE = 3;
const DURATION = { success: 4000, info: 4000, warning: 5000, error: 6000 };

let nextId = 0;
let items = [];
const listeners = new Set();

const emit = () => {
  const snapshot = items;
  listeners.forEach((listener) => listener(snapshot));
};

export const subscribeToasts = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getToasts = () => items;

export const dismissToast = (id) => {
  items = items.filter((item) => item.id !== id);
  emit();
};

export const dismissAllToasts = () => {
  items = [];
  emit();
};

const push = (tone, title, description, options = {}) => {
  if (!title) return null;

  // Repeats stack behind the newest one rather than collapsing into it.
  const id = ++nextId;
  items = [
    ...items,
    {
      id,
      seq: id,
      tone,
      title,
      description: description || null,
      duration: options.duration ?? DURATION[tone],
    },
  ].slice(-MAX_VISIBLE);
  emit();
  return id;
};

/** `toast.success('Documents submitted', 'We review within 1 business day.')` */
export const toast = {
  success: (title, description, options) => push('success', title, description, options),
  error: (title, description, options) => push('error', title, description, options),
  warning: (title, description, options) => push('warning', title, description, options),
  info: (title, description, options) => push('info', title, description, options),
  dismiss: dismissToast,
  dismissAll: dismissAllToasts,
};

export default toast;
